// NPM Imports
import React from "react";
import { connect } from "react-redux";
import {
  REVV_LOGO,
  REVV_LOGO_URL_LZ,
  REVV_LOGO_URL_LZ_MOBILE,
} from "../../../constants/images";

// Methoda imports
import { getRecipientDocUtmParamsUrl } from "../method";

const RevvLogo = ({
  documentPageType: docType,
  stage,
  docName,
  paymentStatus,
  recipientType,
  acceptingStates,
  sharingHash,
  isLz,
}) => {
  const logoUrl = getRecipientDocUtmParamsUrl(
    "LOGO",
    stage,
    docType,
    docName,
    sharingHash,
    paymentStatus,
    recipientType,
    acceptingStates,
    isLz,
  );

  console.debug(logoUrl);
  let envName = process.env.REACT_APP_ENVIRONMENT;
  if (
    envName !== "PRODUCTION" &&
    envName !== "MOJITO" &&
    envName !== "MOJITO_REPLICA" &&
    envName !== "REVV_LZ_DEV" &&
    envName !== "REVV_LZ_QA"
  ) {
    envName = "TEST_ENV";
  }

  let revvLogoURL = REVV_LOGO_URL_LZ[envName];
  let revvLogoURLStyles = { ...REVV_LOGO.RECIPIENT_HEADER.STYLE };

  if (window.innerWidth < 600) {
    revvLogoURL = REVV_LOGO_URL_LZ_MOBILE[envName];
    revvLogoURLStyles = { ...REVV_LOGO.RECIPIENT_HEADER.STYLE_MOBILE };
  }
  // TODO: according to env link to change that need to be implemented
  return (
    <div className="revvlogo-container">
      <a
        href={logoUrl}
        target="_blank"
        rel="noopener nofollow noreferrer"
        className="revvlogo-link"
        style={revvLogoURLStyles}
        data-test="revvlogo-image-hyperlink">
        <img src={revvLogoURL} alt="Revv" className="revvlogo-img" />
      </a>
    </div>
  );
};

const mapStateToProps = state => {
  const { document: { name: docName, stage, paymentStatus } = {} } =
    state.DocumentStore;
  const { recipientType, acceptingStates } = state.SharedDocument;
  const { is_lz: isLz } = state.RevvSignStore;
  return {
    docName,
    stage,
    paymentStatus,
    recipientType,
    acceptingStates,
    isLz,
  };
};

export default connect(mapStateToProps, null)(RevvLogo);
